export default __webpack_public_path__ + "static/4-93648c5a23fb33ff7eb1dd6f5f50793a.jpg";